/**
* 
*/
<template>
  <div>
    <el-button size="small" type="primary" class="title mb20" @click="addForm()">新增</el-button>
    <el-table size="small"
      height="82vh" :data="helpInfo" highlight-current-row v-loading="loading" border
      element-loading-text="拼命加载中" style="width: 100%">
      <el-table-column align="center" prop="IDX" label="排序">
      </el-table-column>
      <el-table-column align="center" prop="HelpTitle" label="标题"></el-table-column>
      <el-table-column
        align="center"
        prop="CREATETIME"
        label="创建时间"
        min-width="120"
      >
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button size="mini" type="text" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <el-button size="mini" type="text" @click="handleFrozen(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 编辑界面 -->
    <el-dialog title="编辑" :visible.sync="editFormVisible" width="60%" @close="closeDialog()">
      <el-form label-width="120px" ref="activeForm" :rules="rules" :model="activeForm">
        <el-form-item label="标题" prop="HelpTitle">
          <el-input v-model="activeForm.HelpTitle" placeholder="不超过10个字"></el-input>
        </el-form-item>
        <el-form-item label="正文" prop="Helptext">
          <el-input type="textarea" v-model="activeForm.Helptext" maxlength="4000"></el-input>
        </el-form-item>
        <el-form-item label="排序" prop="IDX">
          <el-input-number v-model="activeForm.IDX" @change="handleChange" :min="1"></el-input-number>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="editFormVisible = false">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title"
          @click="submitForm('activeForm')">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data () {
    return {
      editFormVisible: false,
      loading: false,
      helpInfo: [],
      rules: {
        HelpTitle: [{ required: true, message: '请输入标题', trigger: 'blur' }],
        Helptext: [{ required: true, message: '请输入正文', trigger: 'blur' }],
        IDX: [{ required: true, message: '请更改排序', trigger: 'change' }]
      },
      activeForm: {
        IDX: 1
      },
      activeIndex: 0
    }
  },
  mounted () {
    this.getData()
  },
  methods: {
    addForm () {
      this.activeForm = { HelpGUID: '', HelpTitle: '', Helptext: '', IDX: '' };
      this.editFormVisible = true
    },
    getData () {
      let personInfo = JSON.parse(this.$util.getStore('personInfo'))
      let data = {
        CompanyGUID: personInfo.CompanyGUID
      };
      this.$loading()
      this.$api.GetHelpCenterList(data).then(result => {
        this.$loading().close()
        if (result.data.OK != 'True') {
          this.$message({
            message: result.data.Message,
            type: 'success'
          });
        } else if (result.data.Tag.length <= 0) {

        } else {
          this.helpInfo = result.data.Tag[0].Table;
        }
      })
    },
    //显示编辑界面
    handleEdit: function (index, row) {
      this.activeForm = row
      this.activeIndex = index
      this.editFormVisible = true
    },
    //显示冻结界面
    handleFrozen: function (index, row) {
      console.log(index, row, 93)
      this.$confirm('确定删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.delete(row.HelpGUID)
      }).catch(() => {

      });
    },

    delete (e) {
      this.$loading();
      this.$api.ExSqlFn('ShopWebApp\\DeleteHelpCenterInfo_1_0_1&DBC=w_m', { HelpGUID: e }).then((res) => {
        this.$loading().close()
        let result = res.data;
        if (result.OK != 'True') {
          this.$message(result.Message)
        } else {
          this.$message('删除成功');
          this.getData()
        }
      })

    },
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          console.log('valid', valid);
          if (this.activeForm.HelpGUID && this.activeForm.HelpGUID.length > 0) {
            this.upData(this.activeForm)
          } else {
            this.$api.returnGuid().then((guid) => {
              this.activeForm.HelpGUID = guid;
              this.upData(this.activeForm)
            })
          }
        } else {
          this.$loading().close()
          return false;
        }
      });

    },
    upData (data) {
      console.log(data, 143)
      let personInfo = JSON.parse(this.$util.getStore('personInfo'))
      data.CompanyGUID = personInfo.CompanyGUID;
      this.$loading()
      this.$api.UpdateHelpCenterInfo(data).then(res => {
        let result = res.data
        this.$loading().close()
        if (result.OK != 'True') {
          this.$message({
            type: 'success',
            message: result.Message
          });
        } else {
          this.$message({
            type: 'success',
            message: '提交成功'
          });
          this.getData()
          this.editFormVisible = false
        }
      })
    },
    handleChange (e) {
      console.log(e, 142)
    }

  }
}
</script>

<style scoped>

</style>




// WEBPACK FOOTER //
// src/views/shop/helpCenter.vue